/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo } from 'react';
// material
import { IncDecField, CardControl } from '@insticator/insticator-ui'
import { SectionGroupV2 } from 'material/expandablesection/v2'
import Space from 'material/space/space'
import PreviewConfig from '../../previewconfig/previewconfig'
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss'
import styles from './commentlimits_styles'



/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : EMOTICON COMMENT REACTIONS ~~~~~~~~~~ ========== */
const CommentLimits = injectSheet(styles)((props) => {
  
  const { treeType, commentsInitialLoadLimit, repliesInitialLoadLimit, commentsLoadMoreLimit, repliesLoadMoreLimit, onChange } = props

  const handleSelectTreeType = type => {
    let selectedTreeTypeLimits = {
      commentsInitialLoadLimit: 5,
      repliesInitialLoadLimit: 1
    }

    switch(type) {
      case 'BASIC':
        selectedTreeTypeLimits.commentsInitialLoadLimit = 5;
        selectedTreeTypeLimits.repliesInitialLoadLimit = 1;
        selectedTreeTypeLimits.commentsLoadMoreLimit = 5;
        selectedTreeTypeLimits.repliesLoadMoreLimit = 5;
        break;
      case 'COMPACT':
        selectedTreeTypeLimits.commentsInitialLoadLimit = 2;
        selectedTreeTypeLimits.repliesInitialLoadLimit = 0;
        selectedTreeTypeLimits.commentsLoadMoreLimit = 2;
        selectedTreeTypeLimits.repliesLoadMoreLimit = 5;
        break;
      case 'ADVANCED':
        selectedTreeTypeLimits.commentsInitialLoadLimit = 10;
        selectedTreeTypeLimits.repliesInitialLoadLimit = 3;
        selectedTreeTypeLimits.commentsLoadMoreLimit = 10;
        selectedTreeTypeLimits.repliesLoadMoreLimit = 5;
        break;
      case 'CUSTOM':
        selectedTreeTypeLimits.commentsInitialLoadLimit = 5
        selectedTreeTypeLimits.repliesInitialLoadLimit = 2
        selectedTreeTypeLimits.commentsLoadMoreLimit = 5
        selectedTreeTypeLimits.repliesLoadMoreLimit = 5
        break;
      default:
        break;
    }

    onChange('commentsInitialLoadLimit', selectedTreeTypeLimits.commentsInitialLoadLimit, {
      commentsInitialLoadLimit: selectedTreeTypeLimits.commentsInitialLoadLimit,
      repliesInitialLoadLimit: selectedTreeTypeLimits.repliesInitialLoadLimit,
      commentsLoadMoreLimit: selectedTreeTypeLimits.commentsLoadMoreLimit,
      repliesLoadMoreLimit: selectedTreeTypeLimits.repliesLoadMoreLimit
    })
  }

  const isTreeTypeBasic = useMemo(() => (commentsInitialLoadLimit === 5 && repliesInitialLoadLimit === 1), [commentsInitialLoadLimit, repliesInitialLoadLimit])

  const isTreeTypeCompact = useMemo(() => (commentsInitialLoadLimit === 2 && repliesInitialLoadLimit === 0), [commentsInitialLoadLimit, repliesInitialLoadLimit])

  const isTreeTypeAdvanced = useMemo(() => (commentsInitialLoadLimit === 10 && repliesInitialLoadLimit === 3), [commentsInitialLoadLimit, repliesInitialLoadLimit])

  return (
    <SectionGroupV2 
      klass={`commentlimits ${props.classes.commentlimits}`}
      title={'Comment tree limits'} 
      description={'Specify how many comments and replies the user will see at a time.'}
      indented
    >
      <Space gap={32} direction={'column'}>
        <Space direction={'column'}>
          <p>Choose </p>
          <Space>
            <CardControl
              title={'Basic'}
              image={`${url.image}/illustrations/illustration-basic.svg`}
              value={'BASIC'}
              handleSelect={handleSelectTreeType}
              selected={isTreeTypeBasic}
            />
            <CardControl
              title={'Compact'}
              image={`${url.image}/illustrations/illustration-compact.svg`}
              value={'COMPACT'}
              handleSelect={handleSelectTreeType}
              selected={isTreeTypeCompact}
            />
            <CardControl
              title={'Advanced'}
              image={`${url.image}/illustrations/illustration-advanced.svg`}
              value={'ADVANCED'}
              handleSelect={handleSelectTreeType}
              selected={isTreeTypeAdvanced}
            />
            <CardControl
              title={'Custom'}
              image={`${url.image}/illustrations/illustration-custom.svg`}
              value={'CUSTOM'}
              handleSelect={handleSelectTreeType}
              selected={!(isTreeTypeBasic || isTreeTypeCompact || isTreeTypeAdvanced)}
            />
          </Space>
          <p>Visible on page load.</p>
          <Space gap={24}>
            <IncDecField
              name={'visiblecomments'}
              label={'Comments'}
              defaultValue={commentsInitialLoadLimit}
              minValue={1}
              maxValue={25}
              handleIncToggle={val => onChange('commentsInitialLoadLimit', val)}
              handleDecToggle={val => onChange('commentsInitialLoadLimit', val)}
              ctaPosition={'inline'}
              disabled={treeType !== 'CUSTOM'}
            />

            <IncDecField
              name={'visiblereplies'}
              label={'Replies'}
              defaultValue={repliesInitialLoadLimit}
              minValue={0}
              maxValue={25}
              handleIncToggle={val => onChange('repliesInitialLoadLimit', val)}
              handleDecToggle={val => onChange('repliesInitialLoadLimit', val)}
              ctaPosition={'inline'}
              disabled={treeType !== 'CUSTOM'}
            />
          </Space>
        </Space>
        
       <Space direction={'column'}>
        <p>Visible when user loads more comments or replies.</p>
          <Space gap={24}>
            <IncDecField
              name={'loadmorecommentslimit'}
              label={'Comments'}
              defaultValue={commentsLoadMoreLimit}
              minValue={1}
              maxValue={25}
              handleIncToggle={val => onChange('commentsLoadMoreLimit', val)}
              handleDecToggle={val => onChange('commentsLoadMoreLimit', val)}
              ctaPosition={'inline'}
            />

            <IncDecField
              name={'loadmorereplieslimit'}
              label={'Replies'}
              defaultValue={repliesLoadMoreLimit}
              minValue={0}
              maxValue={25}
              handleIncToggle={val => onChange('repliesLoadMoreLimit', val)}
              handleDecToggle={val => onChange('repliesLoadMoreLimit', val)}
              ctaPosition={'inline'}
            />
          </Space>
       </Space>
      </Space>
      <PreviewConfig>
        <Space gap={16} alignItem={'center'} direction={'column'}>
          <img
            alt={''}
            className={'previewimg'}
            src={`${url.image}/illustrations/illustration-${treeType.toLowerCase()}-tree.svg`}
          />
        </Space>
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CommentLimits;